export function SendNotificationsFormValidator(value) {

    let errors = {};
    if (!value.occupants) {
        errors.occupants = 'Please select users';
    }
    if (!value.message) {
        errors.message = 'Message is required';
    }
    

    return errors;


}